import {
  BatchStatisticsRegUsrConditionListItem,
  BatchStatisticsRegUsrConditionListItemFromJSON
} from '@/api/models/batch/BatchStatisticsRegUsrConditionListItem'

export interface BatchStatisticsRegUsrSelectItemResult {
  items: BatchStatisticsRegUsrConditionListItem
}

export function BatchStatisticsRegUsrSelectItemResultFromJSON(
  json: any
): BatchStatisticsRegUsrSelectItemResult {
  return {
    items: BatchStatisticsRegUsrConditionListItemFromJSON(json)
  }
}
